module.exports = __webpack_public_path__ + "static/img/male-4.ae3f2e9c.png";